import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export type ReportingYearWindow = { from: number; to: number };

const utcYearStart = (year: number) => dayjs.utc(`${year}-01-01`).startOf('year');

/**
 * `[Jan 1 00:00:00.000Z, Dec 31 23:59:59.999Z]` as epoch millis.
 *
 * Must stay UTC: consumption proration counts whole UTC days, so a local-time
 * `startOf('year')` opens on Dec 31 under a positive offset and pays every
 * boundary-spanning invoice a day it does not cover. Appending `.utc()` to a
 * local `startOf('year')` does not fix that — it changes the display zone, not
 * the instant. Both apps build these windows, so keep one definition.
 */
export const utcYearWindow = (year: number): ReportingYearWindow => ({
  from: utcYearStart(year).valueOf(),
  to: utcYearStart(year).endOf('year').valueOf(),
});

export const utcYearRangeWindow = (endYear: number, windowYears: number): ReportingYearWindow => ({
  from: utcYearWindow(endYear - (windowYears - 1)).from,
  to: utcYearWindow(endYear).to,
});
